import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const IssueDetailsViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
IssueDetailsViewTopBar.displayName = "IssueDetailsViewTopBar"
